import styled from "styled-components";

export const GuidanceCaseOptions = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .selector {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 0 20px;
  }
  .selector-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    &__imgs {
      margin-bottom: 20px;
    }
    &__img {
      margin-bottom: 0;
      object-fit: cover;
      &-patient {
        width: 83px;
        height: 105px;
        /* border-radius: 27px; */
        border: 3.15px solid;
        object-fit: cover;
        border-image-source: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0.32) 100%
        );
        padding: 10px 0;
        border-radius: 15%;
      }
    }
    &__title {
      font-size: 17px;
      color: #707582;
      text-align: center;
    }
  }
  .options {
    margin: 20px;
    width: 100%;
  }
`;

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ disabled }) => (disabled ? "#CFD3DD" : "#F0F0FF")};
  margin-bottom: 10px;
  padding: 16px;
  border-radius: 14px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  &:last-child {
    margin-bottom: 0px;
  }
  .left {
    display: flex;
    align-items: center;
  }
  .number {
    padding: 2px 5px;
    background-color: #ffffff;
    border-radius: 34px;
    font-size: 14px;
    color: ${({ disabled }) => (disabled ? "#CFD3DD" : "#707582")};
    margin-right: 15px;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 20px;
    color: ${({ disabled }) => (disabled ? "#1F1F52" : "#16158a")};
  }
  .right-icon {
    color: ${({ disabled }) => (disabled ? "#1F1F52" : "#6C6BF5")};
    font-size: 13px;
  }
`;
